import { useCallback } from "react";
import { IconDeleteForever, IconEdit } from "@synthesis/shared-icons";
import { parseAsString, useQueryState } from "nuqs";

import { AdminGridTable, type RowMenuData } from "../../../components/admin-console/admin-grid-table";
import { useReferenceDictionaries } from "../hooks/use-reference-dictionaries";
import { WORK_TYPES_COLUMNS, usePageStore, type ReferenceDictionaryItem } from "../reference-document-types-page.lib";

const searchParser = parseAsString.withDefault("").withOptions({ clearOnDefault: true });

/** Таблица «Виды работ»: значения из справочника GET /internal/dictionaries, поиск и меню строки (⋮). */
export const WorkTypesTable = () => {
  const store = usePageStore()!;
  const { plannedWorksTypes, isLoading, isError } = useReferenceDictionaries();
  const [search] = useQueryState("search", searchParser);

  const renderRowMenu = useCallback(
    (workType: ReferenceDictionaryItem): RowMenuData => ({
      scheme: [
        {
          type: "ITEMS",
          elements: [
            { id: "edit", value: "edit", label: "Изменить", icon: <IconEdit className="size-4" aria-hidden /> },
            { id: "delete", value: "delete", label: "Удалить", icon: <IconDeleteForever className="size-4" aria-hidden /> },
          ],
        },
      ],
      state: {
        edit: () => store.setPopupAction({ type: "edit-work-type", workType }),
        // TODO(FRONT-1390): удаление вида работы — после появления бэкенда.
        delete: () => undefined,
      },
    }),
    [store],
  );

  if (isLoading) {
    return <p className="paragraph-base text-type-minor py-8 text-center">Загрузка справочника…</p>;
  }

  if (isError || plannedWorksTypes.length === 0) {
    return <p className="paragraph-base text-type-minor py-8 text-center">Справочник недоступен</p>;
  }

  return (
    <AdminGridTable
      tableId="admin-reference-work-types-table"
      columns={WORK_TYPES_COLUMNS}
      rows={plannedWorksTypes}
      quickFilterText={search ?? undefined}
      renderRowMenu={renderRowMenu}
      className="h-[24rem]"
    />
  );
};
